<template>
  <div v-title :data-title="$route.name">
    <div class="flex">
      <el-card style="min-width: 500px; max-height: 600px">
        <div class="mb_10 flex LH_input font_14 text_bold">
          <span class="mr_5" style="width: 150px">New Category</span>
          <el-input v-model="AddProductType"></el-input>
          <el-button type="primary" size="small" @click="AddProType()"
            >Create</el-button
          >
        </div>
        <el-table
          border
          :header-cell-style="{
            background: '#1484D6',
            color: '#fff',
            padding: ' 5px 0',
          }"
          :data="typeTable"
          max-height="500px"
        >
          <el-table-column
            width="160px"
            align="center"
            label="Product Category"
            prop="ProductTypeName"
          ></el-table-column>
          <el-table-column align="center" label="Action" width="220px">
            <template slot-scope="scope">
              <div class="flex">
                <span
                  class="underline mr_10 color_home pointer"
                  @click="EditType(scope.row)"
                  >Rename</span
                >
                <el-switch
                  @change="
                    VoidType(scope.row.IsDelete, scope.row.ProductTypeId)
                  "
                  v-model="scope.row.IsDelete"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="Enable"
                  inactive-text="Disable"
                  :active-value="0"
                  :inactive-value="1"
                >
                </el-switch>
              </div>
              <!-- <span
                v-if="scope.row.IsDelete === 0"
                class="underline color_red pointer ml_5"
                @click="VoidType(1, scope.row.ProductTypeId)"
                >Disable</span
              >
              <span
                v-else
                class="underline color_red pointer ml_5"
                @click="VoidType(0, scope.row.ProductTypeId)"
                >Enable</span
              > -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="Details">
            <template slot-scope="scope">
              <span
                :class="
                  RowProData.ProductTypeId === scope.row.ProductTypeId
                    ? 'color_home'
                    : ''
                "
                class="underline pointer"
                @click="getProNameList(scope.row)"
                >Edit</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card
        v-show="ShowProductNameArea"
        style="min-width: 600px; max-height: 600px"
      >
        <div class="mb_10 flex text_bold">
          <span class="mr_5">Product Category:</span>
          <span class="ml_5">{{ ProductType }}</span>
        </div>
        <div class="mb_10 flex LH_input font_14 text_bold">
          <span class="mr_5" style="width: 190px">New Model</span>
          <el-input v-model="AddProductName"></el-input>
          <el-button type="primary" size="small" @click="AddProName()"
            >Create</el-button
          >
        </div>
        <el-table
          border
          :header-cell-style="{
            background: '#1484D6',
            color: '#fff',
            padding: ' 5px 0',
          }"
          :data="DataTable"
          max-height="500px"
        >
          <el-table-column
            align="center"
            label="Product Model"
            prop="ProductName"
          ></el-table-column>
          <!-- <el-table-column align="center" label="Action">
            <template slot-scope="scope">
              <span
                class="underline color_home pointer"
                @click="EditName(scope.row)"
                >Rename</span
              >
              <span
                v-if="scope.row.IsDelete === 0"
                class="underline color_red pointer ml_5"
                @click="VoidName(1, scope.row.ProductId)"
                >Disable</span
              >
              <span
                v-else
                class="underline color_red pointer ml_5"
                @click="VoidName(0, scope.row.ProductId)"
                >Enable</span
              >
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="Action" width="220px">
            <template slot-scope="scope">
              <div class="flex">
                <span
                  class="underline mr_10 color_home pointer"
                  @click="EditName(scope.row)"
                  >Rename</span
                >
                <el-switch
                  @change="VoidName(scope.row.IsDelete, scope.row.ProductId)"
                  v-model="scope.row.IsDelete"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="Enable"
                  inactive-text="Disable"
                  :active-value="0"
                  :inactive-value="1"
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Product Description">
            <template slot-scope="scope">
              <span
                :class="
                  ProductName === scope.row.ProductName ? 'color_home' : ''
                "
                class="underline pointer"
                @click="getInformationData(scope.row)"
                >Edit</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card
        v-show="SHowInformationArea"
        class="text_left mr_20"
        style="min-width: 700px"
      >
        <div class="mb_10 flex text_bold">
          <span class="mr_5 color_red">Product Model:</span>
          <span>{{ InformationData.ProductName }}</span>
        </div>
        <div class="mb_10 flex LH_input font_14 text_bold">
          <span class="mr_5 color_red" style="width: 150px">Key Features</span>
          <el-input v-model="InformationData.KeyPrarameters"></el-input>
          <el-button
            type="primary"
            size="small"
            @click="EditProductDetail('KeyPrarameters')"
            >Save</el-button
          >
        </div>
        <div class="mb_10 flex LH_input">
          <span class="font_14 color_red text_bold" style="width: 150px"
            >Product Description</span
          >
          <div style="border: 1px solid #ccc; width: 770px">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="Pageeditor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 300px; overflow-y: hidden"
              v-model="InformationData.Introduction"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreatedPage"
            />
          </div>
          <div style="display: flex; flex-direction: column-reverse">
            <el-button
              type="primary"
              size="small"
              @click="EditProductDetail('Introduction')"
              >Save</el-button
            >
          </div>
        </div>
        <div class="installadd">
          <span class="font_14 text_bold color_red" style="width: 190px">
            Product Picture/Video Upload
          </span>
          <el-row :gutter="24" class="text_left">
            <el-col
              style="background-color: #ddd; border-radius: 5px"
              class="mt_20"
              v-for="(it, i) in PictureData"
              :key="i"
              :span="6"
            >
              <div>
                <div
                  style="
                    width: 150px;
                    background-color: #fff;
                    align-items: center;
                    text-align: center;
                  "
                  class="pos_rel mt_10"
                >
                  <el-image
                    v-if="
                      it.ISImage &&
                      (it.FileFormat != '' || it.FileFormat != null)
                    "
                    :preview-src-list="PictureDataList"
                    style="height: 180px"
                    :src="it.FilePath"
                  />
                  <div
                    class="flex flex_around text_center"
                    v-else-if="it.FileFormat == '' || it.FileFormat == null"
                    style="width: 150px; height: 180px"
                  >
                    <div style="line-height: 1; color: #ccc">Error</div>
                  </div>
                  <video
                    v-else-if="!it.ISImage"
                    style="width: 150px; height: 180px"
                    @click="toggleFullscreen"
                    playsinline
                    webkit-playsinline
                    class="media-content"
                  >
                    <source :src="getVideoSrc(i)" type="video/mp4" />
                    <source :src="getVideoSrc(i)" type="video/webm" />
                    <source :src="getVideoSrc(i)" type="video/ogg" />

                    Your browser does not support the video tag
                  </video>
                  <!-- <video-player
                  v-else
                  class="video-player vjs-custom-skin mb_5"
                  style="width: 150px; height: 180px"
                  :options="{
                    sources: [
                      {
                        src: it.FilePath,
                      },
                    ],
                    height: '180px !important',
                    controls: true,
                    playbackRates: [0.5, 1, 1.5, 2],
                  }"
                >
                </video-player> -->

                  <i
                    @click="DeleteFile(it)"
                    style="
                      position: absolute;
                      right: -5px;
                      top: -5px;
                      background: white;
                      border-radius: 10px;
                    "
                    class="el-icon-circle-close pos_icon font_18"
                  ></i>
                </div>
                <el-checkbox
                  @change="changeCheckbox(it)"
                  class="work_wrap"
                  v-model="it.IsShow"
                  style="margin-left: 2px; max-width: 150px; display: flex"
                  :true-label="1"
                  :false-label="0"
                  >Show in list</el-checkbox
                >
              </div>
            </el-col>

            <el-col :span="6" class="mt_20 ml_20">
              <div>
                <el-upload
                  ref="VideoUpload"
                  class="upload-demo"
                  :headers="headers"
                  drag
                  :show-file-list="false"
                  action="/api/batteryplant/api/ProductAdmin/ProductAdminUploadFile"
                  accept="image/*,video/*"
                  :http-request="
                    (options) => {
                      UploadFile(options, 'Details');
                    }
                  "
                >
                  <div style="line-height: 50px; font-weight: 700">Add</div>
                </el-upload>
                <div class="color_red font_12">466*466</div>
              </div>

              <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
            </el-col>
          </el-row>
        </div>
        <div class="installadd mt_10">
          <span class="font_14 color_red text_bold" style="width: 190px">
            Slider Pictures (PC)
          </span>
          <el-row :gutter="24">
            <div
              class="mt_20 pos_rel"
              v-for="(it, i) in PC_HomeCarouseldata"
              :key="i"
            >
              <el-col
                :span="8"
                style="
                  background-color: #ddd;
                  border-radius: 5px;
                  padding-top: 10px;
                "
              >
                <div
                  style="
                    background-color: #fff;
                    align-items: center;
                    text-align: center;
                  "
                  class="pos_rel"
                >
                  <el-image
                    v-if="it.ISImage"
                    :preview-src-list="PC_HomeCarouseldataList"
                    style="width: 200px; height: 97px"
                    :src="it.FilePath"
                  />
                  <!-- <video-player
                    v-else
                    class="video-player vjs-custom-skin"
                    style="width: 200px"
                    :options="{
                      sources: [
                        {
                          src: it.FilePath,
                        },
                      ],
                      height: '40px',
                      controls: true,
                      playbackRates: [0.5, 1, 1.5, 2],
                    }"
                  >
                  </video-player> -->

                  <i
                    @click="DeleteFile(it)"
                    style="
                      position: absolute;
                      right: -8px;
                      top: -7px;
                      background: white;
                      border-radius: 10px;
                    "
                    class="el-icon-circle-close pos_icon font_18"
                  ></i>
                </div>
                <el-checkbox
                  @change="changeCheckbox(it)"
                  class="work_wrap"
                  v-model="it.IsShow"
                  style="max-width: 200px; display: flex"
                  :true-label="1"
                  :false-label="0"
                  >Show</el-checkbox
                >
              </el-col>
            </div>

            <el-col :span="8">
              <div class="ml_20 mt_20 flex flex_around">
                <el-upload
                  class="upload-demo"
                  :headers="headers"
                  drag
                  :show-file-list="false"
                  action="/api/batteryplant/api/ProductAdmin/ProductAdminUploadFile"
                  accept="image/*"
                  :http-request="
                    (options) => {
                      UploadFile(options, 'PC_HomeCarouselDisplay');
                    }
                  "
                >
                  <div style="line-height: 50px; font-weight: 700">Add</div>
                </el-upload>
                <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                <div class="color_red font_12">1200*600</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="installadd mt_10">
          <span class="font_14 color_red text_bold" style="width: 190px">
            Slider Pictures (Mobile)
          </span>
          <el-row :gutter="24">
            <div
              class="mt_20 pos_rel"
              v-for="(it, i) in H5_HomeCarouseldata"
              :key="i"
            >
              <el-col
                :span="8"
                style="
                  background-color: #ddd;
                  border-radius: 5px;
                  padding-top: 10px;
                "
              >
                <div
                  style="
                    background-color: #fff;
                    align-items: center;
                    text-align: center;
                  "
                  class="pos_rel"
                >
                  <el-image
                    v-if="it.ISImage"
                    :preview-src-list="H5_HomeCarouseldataList"
                    style="width: 200px; height: 190px"
                    :src="it.FilePath"
                  />
                  <!-- <video-player
                    v-else
                    class="video-player vjs-custom-skin"
                    style="width: 200px"
                    :options="{
                      sources: [
                        {
                          src: it.FilePath,
                        },
                      ],
                      height: '40px',
                      controls: true,
                      playbackRates: [0.5, 1, 1.5, 2],
                    }"
                  >
                  </video-player> -->

                  <i
                    @click="DeleteFile(it)"
                    style="
                      position: absolute;
                      right: -8px;
                      top: -5px;
                      background: white;
                      border-radius: 10px;
                    "
                    class="el-icon-circle-close pos_icon font_18"
                  ></i>
                </div>
                <el-checkbox
                  @change="changeCheckbox(it)"
                  class="work_wrap"
                  v-model="it.IsShow"
                  style="margin-left: 2px; max-width: 200px; display: flex"
                  :true-label="1"
                  :false-label="0"
                  >Show</el-checkbox
                >
              </el-col>
            </div>

            <el-col :span="8">
              <div class="ml_20 mt_20 flex flex_around">
                <el-upload
                  class="upload-demo"
                  :headers="headers"
                  drag
                  :show-file-list="false"
                  action="/api/batteryplant/api/ProductAdmin/ProductAdminUploadFile"
                  accept="image/*"
                  :http-request="
                    (options) => {
                      UploadFile(options, 'H5_HomeCarouselDisplay');
                    }
                  "
                >
                  <div style="line-height: 50px; font-weight: 700">Add</div>
                </el-upload>
                <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                <div class="color_red font_12">750*704</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="installadd mt_10">
          <span class="font_14 text_bold" style="width: 190px">
            Product Documents Upload
          </span>
          <el-row :gutter="24">
            <div
              class="mt_20 pos_rel"
              v-for="(item, index) in TechnicalManualData"
              :key="index"
            >
              <el-col
                :span="6"
                style="
                  background-color: #ddd;
                  border-radius: 5px;
                  padding-top: 10px;
                "
              >
                <div style="margin-left: 20px" class="pos_rel" :key="index">
                  <div @click="Download(item)">
                    <div class="flex flex_around">
                      <img style="width: 70px" src="../assets/file-pdf.png" />
                    </div>
                    <div
                      style="width: 150px; margin-left: 20px"
                      class="text_bold work_wrap flex flex_center"
                    >
                      {{ item.FileName }}
                    </div>
                  </div>
                  <i
                    @click="DeleteFile(item)"
                    style="
                      position: absolute;
                      right: 30px;
                      top: 0px;
                      background: white;
                      border-radius: 10px;
                    "
                    class="el-icon-circle-close pos_icon font_18"
                  ></i>
                </div>
              </el-col>
            </div>

            <div class="ml_20 mt_20">
              <el-upload
                class="upload-demo"
                :headers="headers"
                drag
                :show-file-list="false"
                action="/api/batteryplant/api/ProductAdmin/ProductAdminUploadFile"
                accept="application/pdf"
                :http-request="
                  (options) => {
                    UploadFile(options, 'TechnicalManual');
                  }
                "
              >
                <div style="line-height: 50px; font-weight: 700">Add</div>
              </el-upload>
            </div>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { i18nChangeLanguage } from "@wangeditor/editor";
import { get, post } from "../assets/api/api";
import {
  DeleteFile,
  ProductAdminList,
  ProductAdminUploadFile,
  ProductDetailsEdit,
  ProductList,
  ProductRegister,
  ProductTypeList,
  ProductTypeRegister,
  UpdateIsShow,
  VoidRecoverProduct,
  VoidRecoverProductType,
} from "../assets/api/request";
import axios from "axios";
i18nChangeLanguage("en");
export default {
  components: {
    Editor,
    Toolbar,
  },
  data() {
    return {
      AddProductType: "",
      ProductTypeId: 0,
      ProductType: "",
      RowProData: {},
      AddProductName: "",
      ProductId: 0,
      ShowProductNameArea: false,
      SHowInformationArea: false,
      typeTable: [],
      DataTable: [],
      ProductName: "",
      InformationData: {
        KeyPrarameters: "",
        Introduction: "",
        ProductId: 0,
        ProductName: "",
      },
      editorConfig: {
        placeholder: "Please Enter..",
        MENU_CONF: {
          uploadImage: {
            server: "/api/batteryplant/api/ProductAdmin/RichtextUploadeFile",
            headers: {
              token: sessionStorage.getItem("token"),
            },
          },
        },
        codeLangs: [
          //代码语言高亮
          { text: "CSS", value: "css" },
          { text: "HTML", value: "html" },
          { text: "XML", value: "xml" },
          // 其他
        ],
        contentStyle: "p,div { text-align: left; }", // 默认左对齐
        maxLength: 5000,
      },
      toolbarConfig: {
        excludeKeys: [
          "group-video",
          "fullScreen",
          // "group-image",
          "emotion",
          "codeBlock",
          "insertTable",
        ],
      },
      mode: "default", // or 'simple'
      Pageeditor: null,
      headers: {
        token: sessionStorage.getItem("token"),
      },
      UploadData: {},
      PictureData: [],
      playerOptions: {
        //视频url设置,直播流为例
        sources: [
          {
            src: "https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8", //视频文件地址
            type: "application/x-mpegURL", //视频类型，这里可以不写，如果写一定要写对，否则会无法播放
          },
        ],
        // 其他设置项
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //提示信息
        autoplay: true, //是否自动播放
        controls: true, // 是否显示控制栏
        poster: "http://path/to/poster.jpg", //视频封面
      },
      PC_HomeCarouseldata: [],
      PC_HomeCarouseldataList: [],
      H5_HomeCarouseldata: [],
      H5_HomeCarouseldataList: [],
      PictureDataList: [],

      TechnicalManualData: [],
    };
  },
  beforeDestroy() {
    const Pageeditor = this.Pageeditor;
    if (Pageeditor == null) return;
    Pageeditor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  mounted() {
    this.getProTypeList();
  },
  computed: {
    getVideoSrc() {
      return (index) => {
        return this.PictureData[index].FilePath;
      };
    },
  },
  methods: {
    toggleFullscreen(event) {
      const video = event.target;
      // 播放/暂停切换
      if (video.paused) {
        video.play().catch((e) => console.log("播放失败:", e));
      } else {
        video.pause();
      }

      // 全屏请求
      if (document.fullscreenEnabled) {
        if (!document.fullscreenElement) {
          video.requestFullscreen().catch((e) => {
            console.error("全屏失败:", e);
            // 可选：回退到页面全屏
            this.$refs.videoPlayer.classList.add("fullscreen-fallback");
          });
        } else {
          document.exitFullscreen();
        }
      }
    },
    // 添加修改产品类型
    AddProType() {
      if (!this.AddProductType) {
        this.$message.error("Please enter Type Name");
        return;
      }
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        let data = {
          ProductTypeId: this.ProductTypeId,
          ProductTypeName: this.AddProductType,
        };
        post(ProductTypeRegister, data).then((res) => {
          if (res.data.code === 200) {
            this.getProTypeList();
            this.ProductTypeId = 0;
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 产品类型列表
    getProTypeList() {
      get(ProductTypeList).then((res) => {
        this.typeTable = res.data.data;
      });
    },
    // 编辑产品类型按钮
    EditType(row) {
      this.ProductTypeId = row.ProductTypeId;
      this.AddProductType = row.ProductTypeName;
    },
    // 删除/恢复产品类型
    VoidType(type, id) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          get(
            VoidRecoverProductType +
              "?ProductTypeId=" +
              id +
              "&IsDelete=" +
              type
          ).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("Successful.");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .finally(() => {
          this.getProTypeList();
        });
    },
    // 获取产品名称列表
    getProNameList(row) {
      this.RowProData = row;
      this.ProductType = row.ProductTypeName;
      get(ProductList + "?ToProductTypeId=" + row.ProductTypeId).then((res) => {
        if (res.data.code === 200) {
          this.ShowProductNameArea = true;
          this.SHowInformationArea = false;
          this.DataTable = res.data.data;
        }
      });
    },
    getProNameListcopy(row) {
      this.RowProData = row;
      this.ProductType = row.ProductTypeName;
      get(ProductList + "?ToProductTypeId=" + row.ProductTypeId).then((res) => {
        if (res.data.code === 200) {
          this.ShowProductNameArea = true;
          this.DataTable = res.data.data;
        }
      });
    },
    // 添加修改产品名称
    AddProName() {
      if (!this.AddProductName) {
        this.$message.error("Please enter Product Name");
        return;
      }
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        let data = {
          ProductId: this.ProductId,
          ToProductTypeId: this.RowProData.ProductTypeId,
          ProductName: this.AddProductName,
        };
        post(ProductRegister, data).then((res) => {
          if (res.data.code === 200) {
            this.getProNameList(this.RowProData);
            this.ProductId = 0;
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 编辑产品名称按钮
    EditName(row) {
      this.ProductId = row.ProductId;
      this.AddProductName = row.ProductName;
    },
    // 删除/恢复产品名称
    VoidName(type, id) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          get(
            VoidRecoverProduct +
              "?ToProductTypeId=" +
              this.RowProData.ProductTypeId +
              "&ProductId=" +
              id +
              "&IsDelete=" +
              type
          ).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("Successful.");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .finally(() => {
          this.getProNameList(this.RowProData);
        });
    },
    // 产品信息
    getInformationData(row) {
      this.getProNameListcopy(this.RowProData); //防止修改后没提交造成信息错误
      this.ProductName = row.ProductName;
      this.SHowInformationArea = true;
      this.InformationData = row;
      if (!this.InformationData.Introduction) {
        this.InformationData.Introduction = "<p></p>";
      }
      this.getFileList();
    },

    // 产品详细信息编辑
    EditProductDetail(type) {
      if (type === "KeyPrarameters" && !this.InformationData.KeyPrarameters) {
        this.$message.error("Please enter Key Parameters");
        return;
      }
      if (type === "Introduction" && !this.InformationData.Introduction) {
        this.$message.error("Please enter Product Introduction");
        return;
      }
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        let value = "";
        if (type === "KeyPrarameters") {
          value = this.InformationData.KeyPrarameters;
        } else {
          value = this.InformationData.Introduction;
        }
        let data = {
          ProductId: this.InformationData.ProductId,
          Type: type,
          Value: value,
        };
        post(ProductDetailsEdit, data).then((res) => {
          if (res.data.code === 200) {
            this.$message.success("Successful");
          } else {
            this.$message.error(res.data.msg);
            if (type === "KeyPrarameters") {
              this.InformationData.KeyPrarameters = "";
            } else {
              this.InformationData.Introduction = "<p></p>";
            }
          }
        });
      });
    },
    // 上传文件
    UploadFile(options, type) {
      let formdata = new FormData();
      formdata.append("file", options.file);
      console.log(options);

      axios({
        method: "POST",
        url: ProductAdminUploadFile,
        params: {
          ToCaseId: 0,
          ToProductId: this.InformationData.ProductId,
          FileType: type,
          FileFormat: options.file.type,
        },
        data: formdata,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("Successful");

            this.getFileList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          if (type === "Details") {
            this.$refs.VideoUpload.clearFiles();
          }
        });
    },
    // 文件列表
    getFileList() {
      this.PictureData = [];

      get(
        ProductAdminList + "?ToProductId=" + this.InformationData.ProductId
      ).then((res) => {
        // console.log(res);

        this.PictureData = res.data.details;
        this.PictureDataList = [];
        res.data.details.forEach((item, index) => {
          item.ISImage =
            item.FileFormat && item.FileFormat.split("/")[0] === "image";
          item.ISImage ? this.PictureDataList.push(item.FilePath) : "";
        });
        this.PC_HomeCarouseldata = res.data.pcHomeCarouselDisplay;
        this.H5_HomeCarouseldata = res.data.h5HomeCarouselDisplay;
        this.PC_HomeCarouseldataList = [];
        this.H5_HomeCarouseldataList = [];
        this.PC_HomeCarouseldata.forEach((item) => {
          this.PC_HomeCarouseldataList.push(item.FilePath);
          item.ISImage =
            item.FileFormat && item.FileFormat.split("/")[0] === "image";
        });
        this.H5_HomeCarouseldata.forEach((item) => {
          this.H5_HomeCarouseldataList.push(item.FilePath);
          item.ISImage =
            item.FileFormat && item.FileFormat.split("/")[0] === "image";
        });
        this.TechnicalManualData = res.data.technicalManual;
      });
    },
    // 勾选取消
    changeCheckbox(data) {
      get(
        UpdateIsShow + "?FileId=" + data.FileId + "&IsShow=" + data.IsShow
      ).then((res) => {
        if (res.data.code === 200) {
          this.getFileList();
          this.$message.success("Successful");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 删除文件
    DeleteFile(data) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        get(DeleteFile + "?FileId=" + data.FileId).then((res) => {
          if (res.data.code === 200) {
            this.getFileList();
            this.$message.success("Successful.");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    Download(item) {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = item.FilePath;
      a.target = "_blank";
      a.download = item.FileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    onCreatedPage(editor) {
      this.Pageeditor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.upload-imgs {
  position: relative;
  /* width: 150px;
  height: 180px; */
  font-size: 14px;
  display: inline-block;
  padding: 10px;
  /* border: 2px dashed #969799; */
  text-align: center;
  vertical-align: middle;
}
.upload-imgs input {
  opacity: 0;
}
.installadd >>> .el-upload-dragger {
  background-color: #2d8eff;
  color: #fff;
  /* border: 1px dashed #d9d9d9; */
  border-radius: 25px;
  box-sizing: border-box;
  width: 50px;
  height: 50px;
  /* text-align: center; */
  /* cursor: pointer; */
  position: relative;
  overflow: hidden;
}
.video-player .vjs-custom-skin > .video-js {
  max-height: 180px !important;
}
.el-checkbox,
.el-checkbox__label {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}
</style>
